export const trimNewLines = (str) => {
    return str.replace(/^\s+|\s+$/g, '');
};
